/**
 * Chess Piece Base Component
 * Pure logic - symbol lookup only, no styling
 */
import type { PieceProps } from "../../types";
import { getPieceSymbol } from "../../utils";

export interface PieceBaseProps extends PieceProps {
  /** CSS class name for styling */
  className?: string;
  /** Inline styles */
  style?: React.CSSProperties;
}

export function PieceBase({ piece, className, style }: PieceBaseProps) {
  const symbol = getPieceSymbol(piece.color, piece.type);

  return (
    <div className={className} style={style}>
      {symbol}
    </div>
  );
}
